module.exports = __webpack_public_path__ + "img/PT.34f3d78a.svg";